import { useEffect, useState } from "react"

export function useCheckSubdomain() {
    const [domainValid, setDomainValid] = useState<boolean | null>(null)

    useEffect(() => {
        const hostname = window.location.hostname
        const subdomain = hostname.split(".")[0]

        if (hostname.includes(".icont.ai")) {
            fetch(`https://console.icont.ai/api/authentication/check-subdomain?company_domain=${subdomain}`)
                .then((res) => {
                    if (res.status === 200) {
                        setDomainValid(true)
                    } else {
                        setDomainValid(false)
                    }
                })
                .catch(() => setDomainValid(false))
        } else {
            setDomainValid(true) // development, localhost etc
        }
    }, [])

    return domainValid
}
